<nav-bar></nav-bar>
<clp-notification-host></clp-notification-host>
<clp-loading-overlay></clp-loading-overlay>
<div class="container-fluid app-content">
  <router-outlet></router-outlet>
</div>
